import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useTeamData } from '../../app/use-team-data'
import { INQUIRIES_QUERY_KEY, INTERNAL_MEETINGS_QUERY_KEY } from '../../offline/query-keys'
import type { TourOccupancy } from './lib/tour-slot-taken'

/**
 * La tournée et les points internes **en cache local** (D21), que la pré-fiche compare au créneau
 * posé ou déplacé (#669) — **le même depuis les quatre écrans qui l'ouvrent**, comme ses gestes.
 *
 * La tournée se lit sous la clé de toute la tournée, que la coquille lit déjà : la pré-fiche ne
 * coûte aucune lecture de plus. Les points internes se lisent tous — une poignée par semaine —,
 * plutôt que ceux du jour choisi aux roues : la fenêtre ne relit rien quand l'agent les tourne.
 *
 * ⚠️ Rien n'est comparé tant que la lecture n'a pas répondu : l'alerte manque un instant, elle
 * ne bloque jamais rien (M21).
 */
export function useTourOccupancy(): TourOccupancy {
  const data = useTeamData()
  const inquiries = useQuery({
    queryKey: INQUIRIES_QUERY_KEY,
    queryFn: () => data.inquiries.toArray(),
  })
  const meetings = useQuery({
    queryKey: [...INTERNAL_MEETINGS_QUERY_KEY, 'all'],
    queryFn: () => data.internalMeetings.toArray(),
  })

  return useMemo(
    () => ({ inquiries: inquiries.data ?? [], meetings: meetings.data ?? [] }),
    [inquiries.data, meetings.data],
  )
}
